import z from "zod";
import { mapErrorsToFields } from "../../../../utils";
import TemporaryIllnessService from "../../../../services/TemporaryIllnessService";

const api = new TemporaryIllnessService();

export type State = {
  message: string | null;
  errors?: {
    name?: string[];
    general?: string[];
  };
  success: boolean;
  defaultValues: {
    name?: string;
  };
};

const FormSchema = z.object({
  name: z.string().min(1, { message: "Name is required." }),
});

export async function createTemporaryIllness(
  prevState: State,
  formData: FormData
): Promise<State> {
  const defaultValues = {
    name: formData.get("name")?.toString() || "",
  };
  try {
    const validatedFields = FormSchema.safeParse(defaultValues);
    if (!validatedFields.success) {
      return {
        errors: mapErrorsToFields(validatedFields.error),
        message: "Failed to create temporary illness.",
        defaultValues,
        success: false,
      };
    }
    const result = await api.createTemporaryIllness(validatedFields.data);
    if (result.status === 201)
      return {
        errors: {},
        message: "Temporary illness created successfully.",
        defaultValues,
        success: true,
      };
    else if (result.status === 400)
      return {
        errors: {},
        message: result.data.description,
        defaultValues,
        success: false,
      };
  } catch (error) {
    console.error("Error creating temporary illness:", error);
  }
  return {
    errors: {},
    message: "Failed to create temporary illness.",
    defaultValues,
    success: false,
  };
}

export async function updateTemporaryIllness(
  id: number,
  prevState: State,
  formData: FormData
): Promise<State> {
  const defaultValues = {
    name: formData.get("name")?.toString() || "",
  };
  try {
    const validatedFields = FormSchema.safeParse(defaultValues);
    if (!validatedFields.success) {
      return {
        errors: mapErrorsToFields(validatedFields.error),
        message: "Failed to update temporary illness.",
        defaultValues,
        success: false,
      };
    }
    const result = await api.updateTemporaryIllness({
      id: id,
      ...validatedFields.data,
    });
    if (result.status === 204)
      return {
        errors: {},
        message: "Temporary illness updated successfully.",
        defaultValues,
        success: true,
      };
  } catch (error) {
    console.error("Error updating temporary illness:", error);
  }
  return {
    errors: {},
    message: "Failed to update temporary illness.",
    defaultValues,
    success: false,
  };
}

export async function deleteTemporaryIllness(
  id: number
): Promise<{ success: boolean }> {
  try {
    const result = await api.deleteTemporaryIllness(id);
    return { success: result.status === 204 };
  } catch (error) {
    console.error("Database Error:", error);
  }
  return { success: false };
}
